import { useEffect, useState } from "react";
import moment from "moment";

import AnnouncementsService from "../../services/announcements.service";

const getAnnouncementDate = (announcement) =>
  announcement.created_on || announcement.created_at || announcement.created_date;

const isNewAnnouncement = (announcement) => {
  const createdDate = getAnnouncementDate(announcement);

  if (!createdDate) return false;

  return moment(createdDate).isAfter(moment().subtract(30, "days"));
};

const sortByNewest = (announcements) =>
  [...announcements].sort((prev, next) => {
    const prevDate = getAnnouncementDate(prev);
    const nextDate = getAnnouncementDate(next);

    if (!prevDate && !nextDate) return 0;
    if (!prevDate) return 1;
    if (!nextDate) return -1;

    return moment(nextDate).valueOf() - moment(prevDate).valueOf();
  });

const WhatsNew = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "What's New - RueBaRue";

    AnnouncementsService.listAnnouncements()
      .then((response) => {
        setAnnouncements(sortByNewest(response.data || []));
      })
      .catch((err) => {
        console.log("Error loading announcements:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section id="whats-new-page" className="rbr-whats-new-page">
      <div id="hms-page-title">
        <h1 className="uk-heading-small">What's New</h1>
      </div>

      <div id="hms-main-body">
        {loading ? (
          <div className="uk-card uk-card-default uk-card-body rbr-whats-new-empty">
            Loading...
          </div>
        ) : announcements.length === 0 ? (
          <div className="uk-card uk-card-default uk-card-body rbr-whats-new-empty">
            No announcements found.
          </div>
        ) : (
          <div className="rbr-whats-new-list">
            {announcements.map((announcement) => {
              const createdDate = getAnnouncementDate(announcement);

              return (
                <article
                  className="uk-card uk-card-default uk-card-body rbr-whats-new-card"
                  key={`announcement_${announcement.id}`}
                >
                  {announcement.image_url && (
                    <img
                      className="rbr-whats-new-image"
                      src={announcement.image_url}
                      alt=""
                    />
                  )}

                  {announcement.feature_category && (
                    <div className="rbr-whats-new-category">
                      {announcement.feature_category}
                    </div>
                  )}

                  <div className="rbr-whats-new-card-header">
                    <h2>{announcement.title}</h2>
                    {isNewAnnouncement(announcement) && (
                      <span className="rbr-whats-new-badge">New</span>
                    )}
                  </div>

                  {createdDate && (
                    <div className="rbr-whats-new-date">
                      {moment(createdDate).format("MMMM D, YYYY")}
                    </div>
                  )}

                  <p className="rbr-whats-new-description">
                    {announcement.description}
                  </p>

                  <div className="rbr-whats-new-actions">
                    {announcement.video_url && (
                      <a
                        className="uk-button hms-btn hms-white-btn rbr-whats-new-video"
                        href={announcement.video_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Watch Video
                      </a>
                    )}

                    {announcement.link && (
                      <a
                        className="uk-button hms-btn hms-red-btn rbr-whats-new-link"
                        href={announcement.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learn More
                      </a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default WhatsNew;
